import { GlobalState } from '../../../components/actions';

const userGroupTournamentSubscriptionSelector = (state: GlobalState) => state.userGroupTournamentSubscriptions;

export const ugtsEntitySelector = (state: GlobalState) =>
    userGroupTournamentSubscriptionSelector(state).tournamentSubscriptions;
